import { Box, Typography } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux"; // Import useSelector

import { FilterProvider } from "../../components/filters/filter-context";
import { useDateFnsLocale } from "../../utils/date-locale";
import { hasPermission } from "../../utils/helpers";
import TimeOffBalancesReportView from "./ui";

const ManageTimeOffBalancesReport = () => {
	const { t } = useTranslation();
	const dateLocale = useDateFnsLocale();

	const currentUserId = useSelector((state: any) => state.user?.userData?.id);
  const leaveBalanceUpdateEnabled = useSelector((state: any) => state.user?.userData?.leaveBalanceUpdateEnabled);
  const userRolesWithPermissions = useSelector((state: any) => state.user?.userData?.userRolesWithPermissions);
  const canUpdateLeaveBalance =
    leaveBalanceUpdateEnabled && hasPermission(userRolesWithPermissions, "REPORTS.UPDATE_LEAVE_BALANCE");
	return (
		<>
			<Box
				sx={{
					background: "#fff",
					padding: "24px 24px 0px 24px",
					borderRadius: "15px 15px 0px 0px",
				}}
			>
				<Typography
					sx={{
						fontFamily: "Roboto",
						fontSize: "24px",
						fontWeight: 400,
						color: "rgba(0,0,0,0.87)",
					}}
				>
          {canUpdateLeaveBalance ? t("time-off-balances_leave-balance") : t("time-off-balances_leave-balance-report")}
				</Typography>
				<Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
                    {t("time-off-balances_as-of", {
                      // "PPP" is the locale's own long date format, so the
                      // words land in the right order per language ("September
                      // 4th, 2026" / "4 septembre 2026").
                      date: format(new Date(), "PPP", { locale: dateLocale }),
                    })}
                </Typography>
			</Box>
				<Box
				sx={{
					background: "#fff",
					borderRadius: "0px 0px 15px 15px",
				}}
			>
				<FilterProvider filterKey={`time-off-balances-report-${currentUserId}`}>
				<TimeOffBalancesReportView canUpdateLeaveBalance={canUpdateLeaveBalance} />
				</FilterProvider>
				</Box>

		</>
	);
};

export default ManageTimeOffBalancesReport;
